import { format } from "@/lib/format";

const blocker = ["MISSING_NAME", "MISSING_CPF", "MISSING_PHONE"] as const;

interface RecipientSource {
	name: string;
	cpf: string | null;
	cpf_valid: boolean | null;
	phones: { norm: string | null; kind: string; country_code: string | null }[];
	emails: { email: string; invalid: boolean }[];
}

type SignatureRecipientBlocker = (typeof blocker)[number];

export const SignatureRecipient = {
	prepare(source: RecipientSource) {
		const name = source.name.trim();
		const phone = source.phones.find((candidate) => {
			if (candidate.kind !== "mobile") {
				return false;
			}

			if (candidate.country_code !== null && candidate.country_code !== "55") {
				return false;
			}

			if (candidate.norm === null) {
				return false;
			}

			if (candidate.norm.length < 10) {
				return false;
			}

			if (candidate.norm.length > 11) {
				return false;
			}

			return true;
		});
		const email = source.emails.find((candidate) => !candidate.invalid)?.email;
		const blockers: SignatureRecipientBlocker[] = [];

		if (name.split(/\s+/u).length < 2 || /\d/u.test(name)) {
			blockers.push("MISSING_NAME");
		}

		if (source.cpf === null || source.cpf_valid !== true) {
			blockers.push("MISSING_CPF");
		}

		if (phone === undefined) {
			blockers.push("MISSING_PHONE");
		}

		return {
			name,
			cpf: source.cpf_valid === true ? format.cpf(source.cpf) : null,
			phone: phone?.norm,
			phoneDisplay: format.phone(phone?.norm),
			email,
			blockers,
		};
	},
};

export type SignatureRecipientPreparation = ReturnType<typeof SignatureRecipient.prepare>;
